<template>
  <v-flex
    xs12
  >
    <!-- v-resize="getWindowDimensions" -->
    <v-navigation-drawer
      :value="editorProfileDrawerState"
      :permanent="editorProfileDrawerState"
      temporary
      fixed
      absolute
      right
      :width="width"
      style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
      class="bg-gray"
    >
      <v-layout
        wrap
      >
        <v-flex xs12>
          <BaseToolbar
            :title="$t('profile.profile.title')"
            type-title="icon"
            icon="edit"
            :button-save="true"
            @close="closeProfileEditor"
            @save="save"
          />
        </v-flex>
        <v-flex
          xs12
          pa-5
          mt-5
        >
          <v-layout
            row
            wrap
            pa-5
            mt-5
            style="overflow-y: auto;"
          >
            <!-- :style="{ height: `${height}px`, 'max-height': `${height}px` }" -->
            <v-flex xs12>
              <v-card class="afrus-d-rounded-card">
                <v-card-text>
                  <v-layout wrap pt-4>
                    <v-flex xs12 md2 pr-2>
                      <v-select
                        v-model="people.treatment"
                        v-validate="'required'"
                        :data-vv-name="$t('profile.profile.people.treatment.text')"
                        :items="[
                          {
                            text: $t('profile.profile.people.treatment.mrs'),
                            value: 'mrs'
                          },
                          {
                            text: $t('profile.profile.people.treatment.mr'),
                            value: 'mr'
                          }
                        ]"
                        :label="$t('profile.profile.people.treatment.text')"
                        required
                        :error-messages="errors.collect($t('profile.profile.people.treatment.text'))"
                      />
                    </v-flex>
                    <v-flex xs12 md5 px-2>
                      <v-text-field
                        v-model="people.first_name"
                        v-validate="'required'"
                        :data-vv-name="$t('profile.profile.people.firstname')"
                        :label="$t('profile.profile.people.firstname')"
                        required
                        :error-messages="errors.collect($t('profile.profile.people.firstname'))"
                      />
                    </v-flex>
                    <v-flex xs12 md5 pl-2>
                      <v-text-field
                        v-model="people.last_name"
                        v-validate="'required'"
                        :data-vv-name="$t('profile.profile.people.lastname')"
                        required
                        :label="$t('profile.profile.people.lastname')"
                        :error-messages="errors.collect($t('profile.profile.people.lastname'))"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout wrap pt-4>
                    <v-flex xs12 md6 pr-2>
                      <v-select
                        v-model="people.gender"
                        v-validate="'required'"
                        :items="[
                          { text: this.$t('profile.profile.people.gender.female'), value: 'F' },
                          { text: this.$t('profile.profile.people.gender.male'), value: 'M' }
                        ]"
                        :data-vv-name="$t('profile.profile.gender')"
                        :label="$t('profile.profile.gender')"
                        :error-messages="errors.collect($t('profile.profile.gender'))"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 md6 pl-2>
                      <v-autocomplete
                        v-model="people.country_id"
                        v-validate="'required'"
                        :items="countries"
                        item-text="name"
                        item-value="id"
                        :label="$t('profile.profile.country')"
                        :error-messages="errors.collect($t('profile.profile.country'))"
                        :data-vv-name="$t('profile.profile.country')"
                        required
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout wrap pt-4>
                    <v-flex xs12 md6 pr-2>
                      <v-text-field
                        v-model="people.phone"
                        v-validate="{
                          regex: /(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})/
                        }"
                        :data-vv-name="$t('profile.profile.phone')"
                        :label="$t('profile.profile.phone')"
                        :error-messages="errors.collect($t('profile.profile.phone'))"
                      />
                    </v-flex>
                    <v-flex xs12 md6 pl-2>
                      <v-text-field
                        v-model="people.department"
                        :label="$t('profile.profile.department')"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout wrap pt-4 pb-5>
                    <v-flex xs12 md6 pr-2>
                      <v-select
                        v-model="people.language_code"
                        v-validate="'required'"
                        :items="languages"
                        item-text="name"
                        item-value="code"
                        :error-messages="errors.collect($t('profile.profile.language'))"
                        :label="$t('profile.profile.language')"
                        :data-vv-name="$t('profile.profile.language')"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 md6 pl-2>
                      <v-autocomplete
                        v-model="people.time_zone"
                        v-validate="'required'"
                        :items="time_zones"
                        :label="$t('profile.profile.timezone')"
                        :error-messages="errors.collect($t('profile.profile.timezone'))"
                        :data-vv-name="$t('profile.profile.timezone')"
                        required
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
  </v-flex>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import moment from 'moment-timezone'
// import languages from '@/data/languages.json'
import BaseToolbar from '@/components/BaseToolbar'

export default {
  components: {
    BaseToolbar
  },
  created () {
    this.getCountries()
  },
  data: () => ({
    people: {},
    width: 650,
    time_zones: moment.tz.names()
  }),
  watch: {
    profileEdit (newVal, oldVal) {
      if(newVal.id) {
        let {
          gender,
          country_id,
          first_name,
          last_name,
          treatment,
          phone,
          language_code,
          time_zone
        } = newVal.person
        const { department } = newVal
        let people = {
          first_name,
          last_name,
          treatment: treatment === 1 ? 'mrs' : 'mr',
          phone,
          gender,
          country_id,
          language_code,
          time_zone,
          department
        }
        this.people = JSON.parse(JSON.stringify(people))
      }
    },
  },
  methods: {
    ...mapActions({
      getCountries: 'countries/getCountries',
      updateProfile: 'auth/updateProfile'
    }),
    ...mapMutations({
      changeProfileEditor: 'auth/changeProfileEditor',
      editorProfileDrawer: 'auth/editorProfileDrawer'
    }),
    getWindowDimensions () {
      if (process.client) {
        this.width = window.innerWidth > 800 ? window.innerWidth * 0.5 : window.innerWidth
      }
    },
    async save () {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        this.updateProfile({
          ...this.people,
          treatment: this.people.treatment === 'mrs' ? 1 : 2
        })
        .then(
          res => {
            this.$noty.success(this.$t('profile.profile.success'))
            this.closeProfileEditor()
          },
          err => {
            this.$noty.error(this.$t('profile.profile.error'))
          }
        )
      }
    },
    closeProfileEditor() {
      this.changeProfileEditor({})
      this.editorProfileDrawer(false)
    }
  },
  computed: {
    ...mapState({
      countries: ({ countries: { countries } }) => countries,
      languages: ({ auth: { locales } }) => locales,
      editorProfileDrawerState: ({ auth: { editorProfileDrawer } }) => editorProfileDrawer,
      profileEdit: ({ auth: { profileEdit } }) => profileEdit
    })
  }
}
</script>

<style>

</style>